import { useQuery } from "@apollo/client";
import { Theme } from "@emotion/react";
import { SxProps } from "@mui/material";
import { ReactElement } from "react";

import {
  GetPersonalizedGifPreviewLinkQuery,
  GetPersonalizedGifPreviewLinkQueryVariables,
} from "~frontend/__generated__/graphql";
import { GifWithLoadingState } from "~frontend/components/personalizedGifs/GifWithLoadingState";
import { GET_PERSONALIZED_GIF_PREVIEW_LINK } from "~frontend/graphql/personalizedGifs";

import ErrorCard from "../ErrorCard";

export function GifPreview({
  personalizedGifId,
  sx,
  pauseOnMouseOff = true,
}: {
  personalizedGifId: string;
  sx?: SxProps<Theme>;
  pauseOnMouseOff?: boolean;
}): ReactElement {
  const { data, loading, error } = useQuery<
    GetPersonalizedGifPreviewLinkQuery,
    GetPersonalizedGifPreviewLinkQueryVariables
  >(GET_PERSONALIZED_GIF_PREVIEW_LINK, {
    variables: { input: { personalizedGifId } },
  });

  if (error) {
    return <ErrorCard errors={["Error loading personalized GIF"]} />;
  }

  return (
    <GifWithLoadingState
      loading={loading}
      gifUrl={data?.getPersonalizedGifPreviewLink.gifUrl ?? ""}
      pngUrl={data?.getPersonalizedGifPreviewLink.pngUrl ?? ""}
      pauseOnMouseOff={pauseOnMouseOff}
      sx={{ width: "120px", height: "120px", ...sx }}
    />
  );
}
